/**
 * Bygger full URL til backend-API under /api.
 * Bruker alltid relativ sti /api/... slik at backend/proxy styrer miljø.
 * I lokal utvikling håndteres dette av CRA-proxy i package.json.
 *
 * @param {string} path Sti uten ledende slash, f.eks. "auth/check", "form/save"
 */
export function buildApiUrl(path) {
	const cleanPath = path.replace(/^\/+/, '');
	return `/api/${cleanPath}`;
}
